import { Slider as SliderCore, SliderItem, SliderBtn, SliderDrag, SliderDots} from '@studiometa/ui';

/**
 * Slider component
 */
export default class Slider extends SliderCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    components: {
      SliderItem,
      SliderDrag,
      SliderBtn,
      SliderDots,
    },
  };
}
